import { existsCookie } from '@/utils/cookie-list-values';

/**
 * Cookies TrustArc (and the PLI consent integration) writes once a visitor has been
 * presented with, or has acted on, the consent banner. When any of these exist the
 * banner is not expected to render, so no space should be reserved for it.
 */
export const TRUSTARC_CONSENT_COOKIES = [
  'notice_behavior',
  'notice_gdpr_prefs',
  'notice_preferences',
  'cmapi_cookie_privacy'
] as const;

export const hasTrustArcConsentCookies = (): boolean =>
  TRUSTARC_CONSENT_COOKIES.some(cookieName => existsCookie(cookieName));

const isEditMode = (): boolean => {
  const params = window.location.search.split(/[&?]+/);
  return params.includes('epieditmode=true') || params.includes('epieditmode=false');
};

/**
 * Space should only be reserved for first-time visitors, i.e. visitors that do not yet
 * have any TrustArc/PLI consent cookies, and never inside the CMS edit experience.
 */
export const shouldReserveTrustArcSpace = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (isEditMode()) return false;
  return !hasTrustArcConsentCookies();
};
